module.exports = __webpack_public_path__ + "assets/icon-portablePosts-fiberPortable.3cba18e5.svg";